import React from 'react';
import PropTypes from 'prop-types';

import SegmentClient from '../../services/SegmentClient';
import Tooltip from '../Tooltip';
import { PAGE_NAME as DASHBOARD_PAGE_NAME } from '../brand_edit_details/constants';
import { ANALYTICS_NAME } from './Constants';

const segment = new SegmentClient();

export const handlePremiumLearnMore = (page = null, brandId = null, section = null) => {
  segment.track(ANALYTICS_NAME.BRAND_CLICKED_PREMIUM_CTA, {
    brand_id: brandId,
    page_name: page,
    type: section,
  });
};

export const upgradeMessage = clickHandler => (
  <span>
    This feature is available with Premium membership.
    <a
      href="https://join.architizer.com/media-kit/"
      target="_blank"
      rel="noreferrer"
      onClick={clickHandler}
    >
      {' '}
      Learn more
    </a>
    .
  </span>
);

const BrandUpgradeTooltip = ({
  children, isShowable, action, brandId, learnMoreHandler,
}) => (
  isShowable
    ? (
      <Tooltip
        onVisibilityChange={isShown => isShown && segment.track(ANALYTICS_NAME.BRAND_UPGRADE_CTA, {
          brand_id: brandId ? `${brandId}` : null,
          page_name: DASHBOARD_PAGE_NAME,
          type: action,
        })}
        placement="top"
        clickable
        tooltip={upgradeMessage(learnMoreHandler)}
      >
        {children}
      </Tooltip>
    )
    : children
);

BrandUpgradeTooltip.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  isShowable: PropTypes.bool.isRequired,
  action: PropTypes.string.isRequired,
  brandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  learnMoreHandler: PropTypes.func,
};
BrandUpgradeTooltip.defaultProps = {
  brandId: null,
  learnMoreHandler: () => {},
};

export default BrandUpgradeTooltip;
